import { ReorderRuleProduct } from '../../../../ui/pages/Common/ReorderRules/ReorderRuleScreen';
import { ExternalEntityType } from '../../../common/entity';
import { StockLocationAggregateType } from '../../../common/stockLocationAggregateType';
import { Order } from '../../../order';
import { Product } from '../../../product';
import { ProductMasterData } from '../../../product_master_data';
import {
  ProductTransaction,
  ProductTransactionParentType,
  ProductTransactionStatus,
  ProductTransactionType,
} from '../../../productTransaction';
import { ReorderRule } from '../../../reorderRule';
import { UnitOfMeasure } from '../../../uom/unitOfMeasure';
import { Elteros } from '../Elteros';

export namespace ElterosReorderRuleProductTable {
  const EXLCUDED_IN_STOCK_STOCK_LOCATION_IDS = [
    Elteros.centrinisSandelisStockLocationId,
    Elteros.centrinisSandelisTempStockLocationId,
    Elteros.perpard456StockLocationId,
  ];

  export const inStockItem = (
    products: Map<string, Map<string, Product>>,
    productMasterData: Map<string, ProductMasterData>,
    stockLocationIds: string[],
    rule: ReorderRule,
    item: ReorderRuleProduct,
  ) => {
    let inStock = [...(products.get(item.productMasterDataId || '')?.values() || [])];
    if (rule.stockLocationAggregateType === StockLocationAggregateType.allOf) {
      inStock = inStock.filter(p => stockLocationIds.includes(p.stockLocationId));
    }

    inStock = inStock.filter(p => !p.containerId);

    const pmd = productMasterData.get(item.productMasterDataId || '');
    const quantity = inStock.reduce((sum, i) => sum + BigInt(i.unitQuantity), BigInt(0));
    return UnitOfMeasure.toQuantityWithSuffix(pmd?.unitOfMeasure, quantity.toString());
  };

  export const incomingItem = (
    productTransactions: Map<string, ProductTransaction>,
    productMasterData: Map<string, ProductMasterData>,
    orders: Map<string, Order>,
    stockLocationIds: string[],
    rule: ReorderRule,
    item: ReorderRuleProduct,
  ) => {
    let incoming = [...productTransactions.values()].filter(t => {
      if (t.type !== ProductTransactionType.inbound) return false;
      if (t.parentType !== ProductTransactionParentType.order) return false;
      if (t.status !== ProductTransactionStatus.created) return false;
      if (t.product.pmdId !== item.productMasterDataId) return false;

      const order = orders.get(t.parentId || '');
      if (!order) return false;
      if (order.toStockLocationId !== Elteros.perpard456StockLocationId) return false;
      if (order.externalIdentifier?.type !== ExternalEntityType.bc_purchase_order) return false;

      return !t.customFields.get(Elteros.salesOrderNoCustomFieldId)?.value;
    });

    if (rule.stockLocationAggregateType === StockLocationAggregateType.allOf) {
      incoming = incoming.filter(t => stockLocationIds.includes(t.product.toStockLocationId || ''));
    }

    const pmd = productMasterData.get(item.productMasterDataId || '');
    const quantity = incoming.reduce((sum, t) => sum + t.product.quantity, 0);
    return UnitOfMeasure.quantityWithSuffix(pmd?.unitOfMeasure, quantity.toString());
  };
}
